import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LANGUAGES = { tr: "TR", en: "EN", ru: "RU" };

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("mektron_lang") || "tr");

  useEffect(() => {
    localStorage.setItem("mektron_lang", lang);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
